import React from 'react';
import type { InfoRow } from '../types/content';
type InfoTableProps = {
  rows: InfoRow[];
  caption: string;
};
export function InfoTable({
  rows,
  caption
}: InfoTableProps) {
  return <div className="rounded-2xl border border-line bg-surface-2 px-4 pb-2.5 pt-2 md:px-[26px] md:pb-3" data-id="element-56" data-mp="1y6c8mw5to0gq">
      <table className="w-full border-collapse text-[14.5px]" data-id="element-57" data-mp="1t8affieomkrj">
        <caption className="sr-only" data-id="element-58" data-mp="1ta3m2xpap4zj">{caption}</caption>
        <tbody data-id="element-59" data-mp="1o9plu1txqzc2">
          {rows.map(row => <tr key={row.label} className="border-b border-line last:border-b-0" data-id="element-60" data-mp="1jhxwfumimzni">
              <th scope="row" className="w-[38%] py-2.5 pr-3 text-left align-top font-semibold text-muted" data-id="element-61" data-mp="1jfuxum7ary76">
                {row.label}
              </th>
              <td className="break-words py-2.5 align-top font-semibold text-fg" data-id="element-62" data-mp="1aiath4e51lsc">
                {row.lines.map(line => <div key={line.text} data-id="element-63" data-mp="15hn0wea9gww0">
                    {line.href ? <a href={line.href} className="text-accent-soft hover:underline" {...line.href.startsWith('http') ? {
                target: '_blank',
                rel: 'noopener noreferrer'
              } : {}} data-id="element-64" data-mp="10k4vuyzd71ta">
                        {line.text}
                      </a> : line.text}
                  </div>)}
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}